import '@/styles/globals.css'
import { AuthProvider } from '../utils/authContext';
import { PayPalScriptProvider} from "@paypal/react-paypal-js";


export default function App({ Component, pageProps }) {
  return (
    <PayPalScriptProvider
      options={{
        "client-id": "AVtwDRhze1MPVHOhlcvuRIEE1GYC0scv8A_3B7fsCn5Kof74qSnmQdN1zRkaSsD9PBvguxXPBo_0oJ1A",
        "currency": "USD",
      }}
    >
    <AuthProvider>
      <Component {...pageProps} />
    </AuthProvider>
    </PayPalScriptProvider>
  );
}
